module.exports = __webpack_public_path__ + "img/car_shina2_27.9649dc9b.jpg";